// Setup-Service Scope
// -------------------
// Global Scope => defined variables are
//  - $store.globalStore.showSetupServiceModal = true
//  - $store.modalStore.showSetupServiceModalStatus = true
//  - $store.globalStore.showAllSetupServices
//  - $store.modalStore.setupServiceSuccessModalStatus = true
//    $store.modalStore.setupServiceErrorModal = true
//  - $store.modalStore.openModal
//
document.addEventListener('alpine:init', () => {
    window.Alpine.data('setupService', (config) => ({
        modalName: config.modalName ?? '',
        successModal: config.successModal ?? '',
        errorModal: config.errorModal ?? '',
        availableEntries: [],
        selectedEntryIds: [],
        submitValues: [],
        entries: config.entries ?? [],
        contentOpen: false,
        couponCodes: '',
        init() {
            // this value will by default to true unless the form is not submit yet
            this.$store.modalStore[this.modalName + 'Status'] = true;

            // hide other services
            this.$store.globalStore.showAllSetupServices = false;

            let submitButton = document.querySelector('.setupServiceModal form .primary');

            // validate checkboxGroup and set .invalid class to submit button
            this.$watch('selectedEntryIds', ((value) => {
                if(value.length) {
                    submitButton.classList.remove('invalid')
                    submitButton.disabled = false;
                } else {
                    submitButton.classList.add('invalid');
                    submitButton.disabled = true;
                }
            }));
        },
        // show all other services inside the modal
        showServices: {
            ['@click']() {
                this.$store.globalStore.showAllSetupServices = true;
            }
        },
        // open modal and set selected-div as active
        openServiceSetupModal(id) {
            // set global key to true to prevent body scrolling
            this.$store.modalStore.openModal = true;
            if (document.querySelector('form[data-firstfieldautofocus="true"]')) {
                setTimeout(() => initFocusObserverForForms(), 50);
            }
            // open form only if modalNameStatus is not submitted yet, status: ok
            if(this.$store.modalStore[this.modalName + 'Status']) {

                this.$store.modalStore.currentModalName = 'setupServiceModal';
                // reset all important keys
                this.resetKeys();

                // add entry to submitValues array
                this.pushServiceToArray('submitValues', id);

                // push first selection into array
                this.pushServiceToArray('availableEntries', id);

                // fill up rest ob items
                this.setEntriesAsAvailable(id);

                // Push ID into array
                this.pushIdIntoSelectedEntryIds(id);

                this.updateCouponCodes();
            } else {
                // show success modal and say out that the form already was submitted
                this.$store.modalStore.currentModalName = this.successModal;
            }
        },
        // set all entries as available
        setEntriesAsAvailable(id) {
            // set available Entries
            Object.values(this.entries).forEach(item => {
                if(item.id !== id) {
                    this.availableEntries.push(item);
                }
            });
        },
        // add or remove entry from list
        toggleEntry(id) {
            if(this.selectedEntryIds.includes(id)) {
                // remove ID from array
                this.selectedEntryIds = this.selectedEntryIds.filter(function(item){
                    return parseInt(item) !== id;
                });
                // remove object from submitValues array
                this.submitValues = this.submitValues.filter(function(item){
                    return item.id !== id;
                });

                this.updateCouponCodes();
            }
            else {
                // add ID into array
                this.pushIdIntoSelectedEntryIds(id);

                // add entry to submitValues array
                this.pushServiceToArray('submitValues', id);

                this.updateCouponCodes();
            }

            // if submitValues is 0, disable submit button
            this.disableSubmitButtonIfValuesEmpty();
        },
        // push id into selectedEntryIds
        pushIdIntoSelectedEntryIds(id) {
            if(!this.selectedEntryIds.includes(id)) {
                this.selectedEntryIds.push(id);
            }
        },
        // reset all arrays and objects
        resetKeys() {
            this.selectedEntryIds = [];
            this.availableEntries = [];
            this.submitValues = [];
            this.$store.globalStore.showAllSetupServices = false;
        },
        // general function to push data into object
        pushServiceToArray(arrayName, id) {
            Object.values(this.entries).forEach(item => {
                if(item.id === id) {
                    this[arrayName].push(item);
                }
            });
        },
        // no selected services
        disableSubmitButtonIfValuesEmpty() {
            this.$store.globalStore.loading[this.formId] = this.submitValues.length === 0;
        },
        // updates this.couponCodes and updates also the coupon_code input field in the DOM.
        updateCouponCodes() {
            // Extract coupon codes from entries that match submitValues and have a couponCode
            const couponCodes = this.submitValues
                .map(submitValue => this.entries.find(service => service.id === submitValue.id)?.couponCode)
                .filter(Boolean); // Remove undefined values

            // Join coupon codes into a string
            const couponCodesString = couponCodes.join(', ');

            // Set the couponCodes property
            this.couponCodes = couponCodesString;

            // Update the input field value in the DOM
            const couponCodeInput = document.querySelector('#coupon_code-wrapper input[name="coupon_code"]');
            if (couponCodeInput) {
                couponCodeInput.value = couponCodesString;
            }
        },
    }));
})
